import { memo, useEffect, useState } from 'react'
import { css, jsx } from '@emotion/react'
import { useColorMode } from '@chakra-ui/react'
import theme from '../../constants/theme'
import MaxWidth from '../MaxWidth'
import useResponsive from '../../utils/hooks/useResponsive'
import LogoHorizontal from '../LogoHorizontal'
import { Button } from '../chakra/Button'
import Div from '../Div'
import DarkModeToggle from '../DarkModeToggle'
import ImgFallbackProgress from '../ImgFallbackProgress'
import UserProfileImg from '../UserProfileImg'
import { getPublicUser } from '../../services/public'
import { Tooltip } from '../chakra/Tooltip'

const styles = {
  container: colorMode => css`
    background: ${theme.colors.drawer[colorMode]};
    transition: background ${theme.transition.duration.background}, color ${theme.transition.duration.color};
  `,
  darkModeToggle: (darkModeToggleTransform, padding) => css`
    transition: all ${theme.transition.duration.normalSlow};
    transform: ${darkModeToggleTransform};
    margin-right: ${padding};
  `,
  picture: css`
    border-radius: 100%;
  `,
  maxWidth: css`
    padding: 0 !important;
  `,
}

const fetchUser = async (userId, setUser, setErrorUser) => {
  try {
    const user = await getPublicUser(userId)
    setUser(user)
    setErrorUser(false)
  } catch (e) {
    setErrorUser(true)
  }
}

function PublicHeader({ headerHeight, padding, userId }) {
  const [user, setUser] = useState({})
  const [userError, seUserError] = useState(false)
  const { colorMode } = useColorMode()
  const logoSizeH = useResponsive(4, 4.5)
  const logoSizeW = useResponsive(11, 13)
  const darkModeToggleTransform = useResponsive('scale(.68)', 'scale(.75)')
  const pictureSize = useResponsive('30px', '36px')
  const darkModeToggleMr = useResponsive('5px', '13px')

  useEffect(() => {
    if (userId) {
      fetchUser(userId, setUser, seUserError)
    }
  }, [userId])

  return (
    <div css={styles.container(colorMode)}>
      <MaxWidth css={styles.maxWidth}>
        <Div flex spaceBetween centerV height={`${headerHeight}px`} padding={`0 ${padding}`}>
          <Button reset to="/">
            <LogoHorizontal sizeW={logoSizeW} sizeH={logoSizeH} />
          </Button>
          <Div flex centerV>
            <DarkModeToggle css={styles.darkModeToggle(darkModeToggleTransform, darkModeToggleMr)} />
            {!userError && (
              <Tooltip label={`${user.name || 'user'}'s public folder`} placement="bottom">
                <Div center>
                  <UserProfileImg
                    imageUrl={user?.image}
                    email={user?.email}
                    width={pictureSize}
                    height={pictureSize}
                    css={styles.picture}
                    fallback={<ImgFallbackProgress size={pictureSize} radius="100%" />}
                  />
                </Div>
              </Tooltip>
            )}
          </Div>
        </Div>
      </MaxWidth>
    </div>
  )
}

export default memo(PublicHeader)
